module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-zip-0e5c3445.svg";